export const adminMenu = [
  {
    icon: "employee",
    title: "Employees",
  },
  {
    icon: "blog",
    title: "Blog Posting",
  },
  {
    icon: "caseStudies",
    title: "Case Studies",
  },
  {
    icon: "job",
    title: "Job Posting",
  },
  {
    icon: "leave",
    title: "Approve Leaves",
  },
  {
    icon: "wikkipedia",
    title: "HR Wiki",
  },
  {
    icon: "goalsOrOkHours",
    title: "Quarterly Goals",
  },
  {
    icon: "ContactedUser",
    title: "Contacted Users",
  },

];

export const employeeMenu = [
  {
    icon: "wikkipedia",
    title: "HR Wiki",
  },
  {
    icon: "leaveRequest",
    title: "My Leaves",
  },
  {
    icon: "goalsOrOkHours",
    title: "Quarterly Goals",
  },
];
export const lineManagerMenu = [
  {
    icon: "employee",
    title: "Employees",
  },
  {
    icon: "leave",
    title: "Approve Leaves",
  },
  {
    icon: "leaveRequest",
    title: "My Leaves",
  },
  {
    icon: "wikkipedia",
    title: "HR Wiki",
  },
  {
    icon: "goalsOrOkHours",
    title: "Quarterly Goals",
  },
];
